module.exports = __webpack_public_path__ + "media/images/players/OOSTHUIZEN_LOUIS-aa3dd1137d7b02d6bb64ad4a8b2b418f.png";